export default __webpack_public_path__ + "static/media/icomoon2c29.f9bfeb0e.woff";